import { QuickFilter } from '@/components-ant/data-table/quick-filter/QuickFilter';
import { RowActions } from '@/components-ant/data-table/row-actions/RowActions';
import { SearchPanel } from '@/components-ant/data-table/search-panel/SearchPanel';
import { ViewTabs } from '@/components-ant/data-table/views/ViewTabs';

import { BaseDataTable } from './BaseDataTable';

type DataTableInterface = typeof BaseDataTable & {
  SearchPanel: typeof SearchPanel;
  ViewTabs: typeof ViewTabs;
  QuickFilter: typeof QuickFilter;
  RowActions: typeof RowActions;
};

export const DataTable: DataTableInterface = BaseDataTable as DataTableInterface;
DataTable.SearchPanel = SearchPanel;
DataTable.ViewTabs = ViewTabs;
DataTable.QuickFilter = QuickFilter;
DataTable.RowActions = RowActions;

export { useDataTable } from './useDataTable';
export { useDataTableViews } from './views/useDataTableViews';
export { useRowNavigation } from './useRowNavigation';
export { useRowSelection } from './useRowSelection';

export type { DataTableProps } from './BaseDataTable';
export type { Row, Column, DataTableState } from './types';
export type { Filter, FilterSelection, FilterSelections } from './filter-panel/types';
export type { ViewTab, View, AddViewInput } from './views/types';
